import { createSlice } from '@reduxjs/toolkit';
import { OrganSystemReviewForm } from '../../types/types';

type OrganSystemReviewKeys = keyof OrganSystemReviewForm;

interface OrganSystemReviewAction {
  payload: {
    system: OrganSystemReviewKeys;
    active: boolean;
    description: string;
  };
  type: string;
}

const initialOrganSystemReview: OrganSystemReviewForm = {
  neurologico: {
    active: false,
    description: ''
  },
  cardiovascular: {
    active: false,
    description: ''
  },
  respiratorio: {
    active: false,
    description: ''
  },
  digestivo: {
    active: false,
    description: ''
  },
  tegumentario: {
    active: false,
    description: ''
  },
  renal: {
    active: false,
    description: ''
  }
};

const organSystemReviewSLice = createSlice({
  name: 'organSystemReview',
  initialState: initialOrganSystemReview,
  reducers: {
    setSystemActive(state, action: OrganSystemReviewAction) {
      const systemState = state[action.payload.system];
      if (systemState == null) return;
      if (!systemState.active) systemState.description = '';
      systemState.active = action.payload.active;
    },
    setSystemDescription(state, action: OrganSystemReviewAction) {
      const systemState = state[action.payload.system];
      if (systemState == null) return;
      systemState.description = action.payload.description;
    },
    reset() {
      return initialOrganSystemReview;
    }
  }
});

export const organSystemReviewActions = organSystemReviewSLice.actions;

export default organSystemReviewSLice.reducer;
